import { amountModalRecoil } from '@/recoil/atoms/modalRecoil';
import React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import * as S from './Event3Modal.style';

const Event3Modal = () => {
  // 정기결제 동의 모달 상태 관리
  const setAmountModalS = useSetRecoilState(amountModalRecoil);

  const onCloseModal = () => {
    setAmountModalS(false);
  };

  return (
    <S.ServiceTermsOverlay onClick={onCloseModal}>
      {/* 약관 모달 */}
      <div className="serviceTermsContent" onClick={(e) => e.stopPropagation()}>
        <h1>자동 결제 안내</h1>
        <p>
          월간 결제 서비스는 매월 정기적으로 보유하신 캐시로 결제되는 자동결제 방식입니다.
          <br />첫 결제일 기준으로 매월 동일한 날짜에 등록된 결제수단으로 자동결제가 진행됩니다.
          <br />
          결제일 전까지 언제든지 서비스 내 설정에서 자동결제 해지를 요청하실 수 있습니다.
        </p>
        <p>
          ※ 해지 요청이 없는 경우, 다음 결제일에 <strong>자동으로 캐시로 결제</strong>가 이루어집니다.
        </p>
        <button onClick={onCloseModal}>닫기</button>
      </div>
    </S.ServiceTermsOverlay>
  );
};

export default Event3Modal;
